import React from 'react';
import { ChartSpacing, defaultSpacing } from '../../util/spacing';
import { GuidelineGroup } from '../GuidelineGroup';
import css from './index.module.scss';
import classNames from 'classnames';

interface Props<X> {
  width: number;
  height: number;
  xScale: (xValue: X) => number;
  xTicks: X[];
  children: (xValue: X) => string;
  ruler?: boolean;
  rulerLength?: number;
  rotate?: boolean;
  spacing?: ChartSpacing;
  textClass?: (xValue: X) => string;
}

export const BottomAxis = <X,>({
  width,
  height,
  xScale,
  xTicks,
  children,
  ruler = false,
  rulerLength = 8,
  spacing = defaultSpacing,
  rotate,
  textClass,
}: Props<X>) => (
  <GuidelineGroup
    data-component="BottomAxis"
    transform={`translate(0,${height})`}
    width={width}
    height={spacing.bottom}
  >
    {ruler && <line x2={width} stroke="black" strokeWidth={1} />}
    {xTicks
      .map((t: X): [X, number] => [t, xScale(t)])
      .map(([t, o]) => (
        <React.Fragment key={`tick-${o}`}>
          {ruler && <line x1={o} x2={o} y2={rulerLength} />}
          <g
            transform={`translate(${o}, ${spacing.bottom}) ${rotate ? 'rotate(45)' : ''}`}
            className={css.bottomAxis}
          >
            <text
              className={classNames(textClass?.(t) ?? '')}
              textAnchor={rotate ? 'left' : 'middle'}
              alignmentBaseline="after-edge"
            >
              {children(t)}
            </text>
          </g>
        </React.Fragment>
      ))}
  </GuidelineGroup>
);
